export const columns = [
  {
    field: "jobNo",
    headerName: "Job No",
    width: 120,
  },
  { field: "custOrder", headerName: "Cust Order", width: 120 },
  {
    field: "orderLine",
    headerName: "Order Line",
    width: 100,
    align: "center",
  },
  { field: "orderedDate", headerName: "Ordered Date", width: 180 },
  {
    field: "picker",
    headerName: "Picker",
    width: 140,
  },
  { field: "orderLoaded", headerName: "Order Loaded", width: 180 },
  { field: "orderReachedBay", headerName: "Order Reached Bay", width: 180 },
  {
    field: "orderMarkedCompleted",
    headerName: "Order Marked Completed",
    width: 200,
  },
  { field: "totalDuration", headerName: "Total Duration", width: 120 },
];
